/**
 * Renders ghost (preview) pending-placement nodes that follow the cursor.
 * These dashed-outline rectangles appear when the user has confirmed a node's
 * details and needs to click on the canvas to place it.
 */
import React from 'react';
import { NODE_W, NODE_H, splitTitle } from '../../utils/canvasUtils';
import { NodeType, NewNodePayload } from '../../types';

interface PendingNode {
    type: NodeType;
    parentId: string | null;
    data: NewNodePayload;
    alignTop?: boolean;
}

interface PendingNodeLayerProps {
    pendingNewNodes: PendingNode[];
    pendingNodePos: { x: number; y: number } | null;
}

export default function PendingNodeLayer({ pendingNewNodes, pendingNodePos }: PendingNodeLayerProps) {
    if (pendingNewNodes.length === 0 || !pendingNodePos) return null;

    const LINE_HEIGHT = 16;

    return (
        <>
            {pendingNewNodes.map((pending, idx) => {
                const titleLines = splitTitle(pending.data.title || pending.type);
                const totalTextH = titleLines.length * LINE_HEIGHT;
                const textStartY = (NODE_H - totalTextH) / 2 + LINE_HEIGHT / 2;

                return (
                    <g
                        key={`pending-node-${idx}`}
                        transform={`translate(${pendingNodePos.x + idx * (NODE_W + 25) - NODE_W / 2}, ${pendingNodePos.y - NODE_H / 2})`}
                        opacity={0.7}
                        pointerEvents='none'
                    >
                        <rect
                            width={NODE_W}
                            height={NODE_H}
                            rx={2}
                            fill='white'
                            stroke='#999'
                            strokeWidth={2}
                            strokeDasharray='5 4'
                        />
                        {titleLines.map((line, li) => (
                            <text
                                key={li}
                                x={NODE_W / 2}
                                y={textStartY + li * LINE_HEIGHT}
                                fill='#444'
                                fontSize={11}
                                textAnchor='middle'
                                dominantBaseline='middle'
                                style={{ fontFamily: 'var(--font-monospace)' }}
                            >
                                {line}
                            </text>
                        ))}
                    </g>
                );
            })}
        </>
    );
}
